import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import { AppContext } from '/providers/app-context'
import PageWrapper from '/components/page-wrapper'
import HelpText from '/help/billing-credit-usage'
import Menu from '/components/billing/nav-menu'
import CreditUsage from '/components/billing/credit-usage'

const BillingCreditUsage = () => {
  const navigate = useNavigate()
  const { user } = useContext(AppContext)

  if (user?.permissions.client_admin) return (
    <PageWrapper title="Billing Credit Usage" HelpText={HelpText} heading="Credit Usage" menu={<Menu />}>
      <div className='flex flex-col'>
        <CreditUsage />
      </div>
    </PageWrapper>
  )
  else navigate("/")
}

export default BillingCreditUsage
